import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import {
  getListNguonVon,
  updateDataSearch,
} from "../../../../actions/NguonVon";
import { currentDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import userApi from "../../../../service/userApi";
import NguonVonApi from "../../../../service/nguonVonApi";
import { GiaoDichGopVon } from "./GiaoDichGopVon";
import { ThongTinNguoiGop } from "./ThongTinNguoiGop";
export const ModalRutVon = (props) => {
  const dataSearch = useSelector((state) => state.dataSearchNguonVon);
  const dispatch = useDispatch();
  const [isSubbmit, setIsSubmit] = useState(false);
  const initData = {
    customerId: props.customerId,
    ngaygiaodich: currentDate(),
    nhanviengiaodich: "",
    sotien: 0,
    ghichu: "",
  };
  const [dataNguonVon, setDataNguonVon] = useState(initData);

  const initDataThongTin = {
    ten: "",
    ngaysinh: "",
    diachi: "",
    dienthoai: "",
    cmnd: "",
    ngaycap: "",
    noicap: "",
  };
  const [dataThongTin, setDataThongTin] = useState(initDataThongTin);

  const updateDropdown = (field) => (e) => {
    setDataNguonVon({
      ...dataNguonVon,
      [field]: e.target.value,
    });
    if (e.target.value === "" || e.target.value === "0") {
      setErrors1({
        ...errors1,
        nhanviengiaodich: "Chọn nhân viên giao dịch",
      });
    } else {
      setErrors1({
        ...errors1,
        nhanviengiaodich: "",
      });
    }
  };

  //Set Data khi Update trường dữ liệu
  const updateTextValue = (field) => (e) => {
    setDataNguonVon({
      ...dataNguonVon,
      [field]: e.target.value,
    });
    if (e.target.value === "") {
      setErrors3({
        ...errors3,
        ghichu: "Vui lòng nhập ghi chú",
      });
    } else {
      setErrors3({
        ...errors3,
        ghichu: "",
      });
    }
  };
  const onChangeNumber = (field) => (evt) => {
    setDataNguonVon({
      ...dataNguonVon,
      [field]: convertToNumber(evt.target.value),
    });
    if (evt.target.value === "") {
      setErrors2({
        ...errors2,
        sotien: "Vui lòng Nhập số tiền",
      });
    } else if (evt.target.value === 0) {
      setErrors2({
        ...errors2,
        sotien: "Vui lòng Nhập số tiền",
      });
    } else {
      setErrors2({
        ...errors2,
        sotien: "",
      });
    }
  };

  const onChangeDate = (field) => (evt) => {
    setDataNguonVon({
      ...dataNguonVon,
      [field]: formatDayMonth(evt),
    });
    if (evt === "null") {
      setErrors4({
        ...errors4,
        ngaygiaodich: "Nhập ngày giao dịch",
      });
    } else {
      setErrors4({
        ...errors4,
        ngaygiaodich: "",
      });
    }
  };

  const dataOption = {
    nguoiTaoOption: [
      {
        label: "Nguyễn Thị Thu Hằng",
        value: "Nguyễn Thị Thu Hằng",
      },
      {
        label: "Trần Văn B",
        value: "Trần Văn B",
        selected: true,
      },
    ],
  };

  const [listUser, setListUser] = useState(dataOption.nguoiTaoOption);
  useEffect(() => {
    NguonVonApi.chiTietNguonVon(props.customerId).then((response) => {
      setDataThongTin({
        ...dataThongTin,
        ten: response.data.Ten,
        ngaysinh: response.data.NgaySinh,
        diachi: response.data.DiaChi,
        dienthoai: response.data.SoDienThoai,
        cmnd: response.data.CMND,
        ngaycap: response.data.NgayCap,
        noicap: response.data.NoiCap,
      });
    });

    userApi.combo().then((response) => {
      const dataComboUser = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setListUser(dataComboUser);
    });
  }, []);

  //Thông báo

  const initErrors1 = {
    nhanviengiaodich: "",
  };
  const [errors1, setErrors1] = useState(initErrors1);
  const initErrors2 = {
    sotien: "",
  };
  const [errors2, setErrors2] = useState(initErrors2);
  const initErrors3 = {
    ghichu: "",
  };
  const [errors3, setErrors3] = useState(initErrors3);
  const initErrors4 = {
    ngaygiaodich: "",
  };
  const [errors4, setErrors4] = useState(initErrors4);
  const onSubmit = () => {
    if (
      dataNguonVon.nhanviengiaodich === listUser[0].value ||
      dataNguonVon.nhanviengiaodich === ""
    ) {
      setErrors1({
        ...errors1,
        nhanviengiaodich: "Chọn nhân viên giao dịch",
      });
      return;
    } else if (dataNguonVon.sotien === 0 || dataNguonVon.sotien === "") {
      setErrors2({
        ...errors2,
        sotien: "Vui lòng Nhập số tiền",
      });
      return;
    } else if (dataNguonVon.ghichu === "") {
      setErrors3({
        ...errors3,
        ghichu: "Vui lòng nhập ghi chú",
      });
      return;
    } else if (
      dataNguonVon.ngaygiaodich === "null" ||
      dataNguonVon.ngaygiaodich === null ||
      dataNguonVon.ngaygiaodich === ""
    ) {
      setErrors4({
        ...errors4,
        ngaygiaodich: "Nhập ngày giao dịch",
      });
      return;
    } else {
      setIsSubmit(true);
      NguonVonApi.addRutVon(
        dataNguonVon.customerId,
        dataNguonVon.ngaygiaodich,
        dataNguonVon.nhanviengiaodich,
        dataNguonVon.sotien,
        dataNguonVon.ghichu
      ).then((response) => {
        setIsSubmit(false);
        if (response.data.Error === 1) {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
          return;
        } else {
          // showAlert();
          pushNotification(
            "Bạn đã rút vốn thành công",
            "success",
            "TOP_CENTER",
            1000
          );
          props.onHide();
          dispatch(getListNguonVon(dataSearch));
        }
      });
    }
  };

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-currency-usd-off"></i>
          </span>{" "}
          Rút vốn
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form class="form tat-toan form-horizontal form-edit">
          <div class="form-body">
            <div class="card collapse-icon accordion-icon-rotate">
              <div class="card-header border-info">
                <a class="card-title lead info collapsed" href={() => false}>
                  <h3>Thông tin người góp vốn</h3>
                </a>
              </div>
              <ThongTinNguoiGop dataThongTin={dataThongTin} />
              <br />
              <GiaoDichGopVon
                dataNguonVon={dataNguonVon}
                onChangeDate={onChangeDate}
                updateTextValue={updateTextValue}
                onChangeNumber={onChangeNumber}
                listUser={listUser}
                updateDropdown={updateDropdown}
                errors1={errors1}
                errors2={errors2}
                errors3={errors3}
                errors4={errors4}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>

        {isSubbmit == false && (
          <>
            <button
              className="btn btn-new-main btn-checknew"
              href={() => false}
              onClick={onSubmit}
            >
              <span>
                <img src="/app-assets/images/icon-save-v2-white.png" />
              </span>
              &nbsp; Thêm mới &nbsp;
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};
